import {h, Fragment} from "preact"
import { usePagination, useActions } from '@nosto/preact'

export default () => {
    const pagination = usePagination({
        width: 5
    })
    const { updateSearch } = useActions()

    const createCallback = (from) => () => {
        updateSearch({
            products: {
                from,
            },
        })
        scrollTo(0, 0)
    }

    return (
        <nav role="navigation">
            <ol class="pagination plp-pagination">
                {pagination.prev && (
                    <li class="plp-pagination--pager first">
                        <a
                            href="javascript:void(0)"
                            aria-label="Previous"
                            onClick={createCallback(pagination.prev.from)}
                        >
                            <span aria-hidden="true">&laquo;&nbsp;</span><span class="mobile-hidden">Prev</span><span class="sr-only">ious page</span>
                        </a>
                    </li>
                )}

                {pagination.first && (
                    <>
                        <li class="plp-pagination--link">
                            <a href="javascript:void(0)" onClick={createCallback(pagination.first.from)}>
                                {pagination.first.page}
                            </a>
                        </li>
                        <li class="plp-pagination--marker">&hellip;</li>
                    </>
                )}

                {pagination.pages.map((page) => {
                    let attrs = {};
                    let classNames = '';
                    if (page.current) {
                        classNames = 'plp-pagination--current active';
                        attrs["aria-current"] = "page";
                    }
                    return (
                        <li class={`plp-pagination--link ${classNames}`} {...attrs}>
                            {page.current ? (
                                <>
                                    <span class="sr-only">page </span><span>{page.page}</span>
                                </>) : (
                                <a href="javascript:void(0)" onClick={createCallback(page.from)}>
                                    {page.page}
                                </a>
                            )}
                        </li>
                    );
                })}

                {pagination.last && (
                    <>
                        <li class="plp-pagination--marker">&hellip;</li>
                        <li class="plp-pagination--link">
                            <a href="javascript:void(0)" onClick={createCallback(pagination.last.from)}>
                                {pagination.last.page}
                            </a>
                        </li>
                    </>
                )}

                {pagination.next && (
                    <li class="plp-pagination--pager">
                        <a
                            href="javascript:void(0)"
                            aria-label="Next"
                            onClick={createCallback(pagination.next.from)}
                        >
                            <span class="mobile-hidden">Next</span> <span class="sr-only">page</span>
                            <span aria-hidden="true">&nbsp;&raquo;</span>
                        </a>
                    </li>
                )}
            </ol>
        </nav>
    )
}
